import DateFnsUtils from '@date-io/date-fns'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'

interface Props {
  disablePast?: boolean
  disableFuture?: boolean
  value: MaterialUiPickersDate
  setValue: (date: MaterialUiPickersDate) => void
  className?: string
}

const Datepicker = ({
  disablePast = true,
  disableFuture = false,
  value,
  setValue,
  className,
  ...restProps
}: Props) => {
  const handleDateChange = (date: MaterialUiPickersDate) => {
    setValue(date)
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={`datepicker ${className}`}
        disablePast={disablePast}
        disableFuture={disableFuture}
        disableToolbar
        variant="inline"
        format="MM/dd/yyyy"
        margin="normal"
        value={value}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        InputProps={{
          disableUnderline: true,
        }}
        {...restProps}
      />
    </MuiPickersUtilsProvider>
  )
}

export default Datepicker
